<template>
  <admin-layout title="Testes Bigfive" menu="Testes">
    <div class="row mb-2">
      <div class="col-lg-10 col-xs-12 pr-2">
        <div class="block_info_white p-2">
          <div class="row">
            <div class="col-lg-5 col-xs-12">
              <div class="form-group mb-0 has-search">
                <span
                  class="fa fa-search ml-2 mt-2 form-control-feedback"
                ></span>
                <input
                  type="text"
                  v-model="search"
                  v-on:keyup.enter="searchBigfives"
                  class="form-control no_border bg_grey"
                />
              </div>
            </div>
            <div class="col-lg-5 col-xs-12"></div>
            <div class="col-lg-2 col-xs-12">
              <div class="pt-2">
                <span class="mr-2">
                  <b>TESTES</b>
                </span>
                <span class="block_info">
                  <b>{{ totalBigfives }}</b>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-lg-2 pl-0">
        <inertia-link href="/recruiters/assessments/bigfives/new">
          <button type="button" class="btn full btn-degrade right">
            <b>NOVO TESTE</b>
          </button>
        </inertia-link>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <table class="table_jovool">
          <thead class="headerTable">
            <tr>
              <td>
                TÍTULO
                <OrderTable entity="bigfive" field="title" />
              </td>
              <td class="center">
                TIPO
                <OrderTable entity="bigfive" field="status" />
              </td>
              <td class="center">
                DATA DE CRIAÇÃO
                <OrderTable entity="bigfive" field="created_at" />
              </td>
              <td class="center">URL</td>
              <td class="center"></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="bigfive in bigfives" :key="bigfive.id">
              <td>
                <b class="color-grey-primary">{{ bigfive.name }}</b>
              </td>
              <td class="center">
                {{ bigfive.status ? "Privado" : "Publico" }}
              </td>
              <td class="center color-grey">
                {{ new Date(bigfive.created_at) | date }}
              </td>
              <td class="center">
                <span
                  class="pointer color-grey"
                  v-clipboard:copy="bigfive.url"
                  v-clipboard:success="onCopy"
                >
                  <font-awesome-icon icon="paperclip" />
                </span>
              </td>
              <td class="center">
                <inertia-link
                  class="color-grey"
                  :href="'/recruiters/assessments/bigfives/' + bigfive.id"
                >
                  <font-awesome-icon icon="pencil-alt" />
                </inertia-link>
              </td>
            </tr>
          </tbody>
        </table>
        <v-pagination
          v-model="currentPage"
          :page-count="pageCount"
          class="justify-content-center"
          :class="firstLoad ? 'd-none' : 'd-flex'"
          :classes="bootstrapPaginationClasses"
        ></v-pagination>
      </div>
    </div>
  </admin-layout>
</template>

<script>
import OrderTable from "components/OrderTable.vue";
import vPagination from "vue-plain-pagination";
export default {
  components: { OrderTable, vPagination },
  data: () => ({
    search: "",
    loading: false,
    totalBigfives: 0,
    currentPage: 1,
    field: "",
    order: "",
    search: "",
    pageCount: 1,
    firstLoad: true,
    bigfives: [],
    bootstrapPaginationClasses: {
      ul: "pagination",
      li: "page-item",
      liActive: "active",
      liDisable: "disabled",
      button: "page-link",
    },
  }),
  mounted() {
    eventBus.$on("orderColumnbigfive", (fields) => {
      this.field = fields.field;
      this.order = fields.order;
      this.searchBigfives();
    });
    this.searchBigfives();
  },
  watch: {
    currentPage: function () {
      this.searchBigfives();
    },
  },
  methods: {
    onCopy: function (e) {
      this.$toast.success("LINK COPIADO COM SUCESSO");
    },
    searchBigfives() {
      let params = {};
      // if (reset_page) this.currentPage = 1;
      if (this.field != "") {
        params["order"] = {};
        params["order"][this.field] = this.order;
      } else {
        params["order"] = {};
        params["order"]["created_at"] = "desc";
      }
      params["search"] = this.search;
      if (this.search === "") {
        params["search"] = "*";
      }
      if (this.status != "") {
        params["status"] = this.status;
      }

      this.loading = true;
      axios
        .get(`/recruiters/assessments/bigfives/search/${this.currentPage}`, {
          params: params,
        })
        .then((response) => {
          this.bigfives = response.data.bigfives;
          this.totalBigfives = response.data.meta.total_bigfives;
          this.pageCount = Math.ceil(this.totalBigfives / 10);
          this.firstLoad = false;
          this.loading = false;
          return;
        });
    },
  },
};
</script>

<style>
</style>